import {Injectable} from "@angular/core";
import {environment} from "../../../../environments/environment";

const baseUrl: string = "https://storage.googleapis.com"

@Injectable({
    providedIn: 'root'
})
export class ProfileImageService {
    getImagePath(name: string | null): string | null {
        if (!name) {
            return null;
        }
        return `${baseUrl}/${environment.getCloudBucket("avatars")}/${name}`
    }
}